/* 宿舍管理模块API */

import { GET, GETNEW, POST, POSTNEW, download, uploading, POSTFormData, POSTFormDataNEW, EXPORT, DELETE, PUT, DELETEBODY, EXPORTNEW } from '@/request/http'
// 宿舍用途
// 获取宿舍用途
export const getDormUseTable = p => GET('/dormv2/use/list', p, 4)
// 获取宿舍用途根据id
export const getDormUseById = p => GET('/dormv2/use/get', p, 4)
// 新增宿舍用途
export const addDormUse = p => POST('/dormv2/use/save', p, 4)
// 编辑宿舍用途
export const editDormUse = p => PUT('/dormv2/use/update', p, 4)
// 删除宿舍用途
export const delDormUse = p => DELETEBODY('/dormv2/use/remove', p, 4)
// 分页获取宿舍用途
export const getDormUseTablePage = p => GET('/dormv2/use/page', p, 4)

//宿舍房型
// 获取宿舍房型
export const getDormSpecTable = p => GET('/dormv2/spec/list', p, 4)
// 获取宿舍房型根据id
export const getDormSpecById = p => GET('/dormv2/spec/get', p, 4)
// 新增宿舍房型
export const addDormSpec = p => POSTFormData('/dormv2/spec/save', p, 4)
// 编辑宿舍房型
export const editDormSpec = p => POSTFormData('/dormv2/spec/update', p, 4)
// 删除宿舍房型
export const delDormSpec = p => DELETEBODY('/dormv2/spec/remove', p, 4)
// 分页获取宿舍房型
export const getDormSpecTablePage = p => GET('/dormv2/spec/page', p, 4)

// 宿舍管理
// 宿舍分页查询
export const getDormTable = p => GET('/dormv2/room/page', p, 4)
// 新增宿舍
export const addDorm = p => POST('/dormv2/room/save', p, 4)
// 编辑宿舍
export const editDorm = p => PUT('/dormv2/room/update', p, 4)
// 编辑宿舍（新）
export const editDormNew = p => PUT('/dormv2/room/updateDormInfo', p, 4)
// 删除宿舍
export const delDorm = p => DELETEBODY('/dormv2/room/remove', p, 4)
// 根据id查询宿舍信息
export const getDormTableById = p => GET('/dormv2/room/get', p, 4)
//宿舍信息导入模板下载
export const importDormInfoModelUpload = p => download('/dormv2/room/dormTemplate', p, 4)
//宿舍信息导入
export const importDormInfo = p => POSTFormData('/dormv2/room/import', p, 4)
//宿舍信息导出
export const exportDormInfo = p => EXPORT('/dormv2/room/exportDorm', p, 4)
//批量删除宿舍
export const batchDelDorm = p => DELETEBODY('/dormv2/room/removeBatch', p, 4)

// 床位分页查询
export const getBedTable = p => GET('/dormv2/bed/page', p, 4)

//床位划分计划
// 新增划分计划
export const addDormDividePlan = p => POST('/dormv2/divide/plans', p, 4)
// 删除划分计划
export const delDormDividePlan = p => DELETE('/dormv2/divide/plans', p, 4)
// 编辑划分计划
export const editDormDividePlan = p => PUT('/dormv2/divide/plans', p, 4)
// 更新划分计划（完成）
export const doneDormDividePlan = p => PUT('/dormv2/divide/plans/done', p, 4)
// 分页获取划分计划
export const getDormDividePlanTablePage = p => GET('/dormv2/divide/plans/page', p, 4)

// 划分计划新增、编辑分配计划
export const addDormDivideInfo = p => POST('/dormv2/divide/infos', p, 4)
//删除具体床位划分信息
export const delSpecificDormDividePlan = p => DELETE('/dormv2/divide/infos', p, 4)
//根据计划D获取全部床位划分信息
export const getAllDividePlanById = p => GET('/dormv2/divide/infos', p, 4)

//床位分配计划
// 获取分配计划详情根据id
export const getDormAssignPlanById = p => GET('/dormv2/assign/infos', p, 4)
// 删除分配计划
export const delDormAssignInfo = p => DELETE('/dormv2/assign/infos', p, 4)
// 更新分配计划（完成）
export const doneDormAssignPlan = p => PUT('/dormv2/assign/infos', p, 4)
// 分页获取分配计划
export const getDormAssignInfoTablePage = p => GET('/dormv2/assign/infos/page', p, 4)
// 保存或更新分配信息
export const saveOrUpdateAssignInfo = p => POST('/dormv2/assign/infos', p, 4)

//查询什么人列表
export const getApproverList = p => POST('/dormv2/adjustapplication/approver/list', p, 5)

//入住管理
//办理入住
export const checkStudentInDorm = p => POST('/dormv2/living', p, 4)
//分页获取入住信息
export const getCheckStudentInTablePage = p => GET('/dormv2/living/page', p, 4)
//批量释放床位
export const batchReleaseBedLiving = p => DELETEBODY('/dormv2/bed/releaseBatch', p, 4)
//入住导入模板下载
export const importCheckInModelUpload = p => download('/dormv2/livingTemplate', p, 4)
//宿舍入住导入
export const importCheckIn = p => POSTFormData('/dormv2/importLiving', p, 4)

//根据学号查询学生的入住信息
export const getStudentBedInfoByNum = p => GET('/dormv2/bed/info', p, 4)

//退换寝管理
//分页获取退换寝信息
export const getExchangeAPurchaseTablePage = p => GET('/dormv2/returnOrExchange/page', p, 4)
//办理退寝
export const checkExchangeAPurchase = p => POSTFormData('/dormv2/returnOrExchange', p, 4)
//判断床位是否入住
export const judgeBedOrCheckIn = p => GET('/dormv2/isLiving', p, 4)
//批量退换寝
export const checkExchangeAPurchaseBatch = p => POSTFormData('/dormv2/returnOrExchange/batch', p, 4)
//根据学号获取学生和当前床位信息
export const getStudentBedInfoByStudentNo = p => GET('/dormv2/bed/{studentNo}/info', p, 4)

// 入住
export const dormCheckIn = p => POST('/dormv2/student/checkInStu', p, 4)
// 退寝
export const dormOut = p => POST('/dormv2/out', p, 4)
// 换寝
export const dormExchange = p => POST('/dormv2/exchange', p, 4)
// 导入寝室
export const importDorm = p => POST('/dormv2/importdorm', p, 4)
// 导入入住
export const importBed = p => POST('/dormv2/importbed', p, 4)

/**
 * 入退换申请审批查看
 */
//入退换申请
export const submitInReturnApply = p => POSTFormData('/dormv2/adjustapplication/submit', p, 4)
//综合查询
export const applicationPage = p => POST('/dormv2/adjustapplication/page', p, 4)
//查询申请单详情
export const byApplicationNo = p => POST('/dormv2/adjustapplication/get/byapplicationno', p, 4)
//指定订单设置审批人
export const assignApprover = p => POST('/dormv2/adjustapplication/assignapprover', p, 4)
//审批人审批
export const approverExamine = p => POST('/dormv2/adjustapplication/approve', p, 4)
//查看该我审核的申请
export const waitApprovePage = p => POST('/dormv2/adjustapplication/approve/page/bycurrentuser', p, 4)
//查看该我审核历史
export const getMytApproveHistoryList = p => POST('/dormv2/adjustapplication/approve-history', p, 4)
// 分配审核人，驳回接口
export const rejectReview = p => PUT('/dormv2/adjustapplication/reject', p, 4)

//查询我自己的申请记录
export const getMyApplicationRecordList = p => POST('/dormv2/adjustapplication/page/bycurrentuser', p, 4)
//撤回我自己的申请记录
export const withdrawMyApplicationRecord = p => POST('/dormv2/adjustapplication/withdraw', p, 4)
//导出入退换申请
export const exportDormPage = p => EXPORT('/dormv2/adjustapplication/export', p, 4)

//根据校区查询区域楼宇
export const getAreaBuildingByCampus = p => POST('/basic/location/areaandbuildingtree/list/bycampusid', p, 4)
//获取当前用户的校区id
export const getCurrentUserCampusId1 = p => GET('/dormv2/getCampusId', p, 4) //弃用
//查询位置列表 当前用户的校区id
export const getCurrentUserCampusId = p => GET('/basic/locations', p, 4)

//考核项管理
//考核项查询
export const getDormCheckList = p => GET('/dormv2/checks', p, 4)
//新增考核项
export const addOneDormCheck = p => POST('/dormv2/checks', p, 4)
//编辑考核项
export const editOneDormCheck = p => PUT('/dormv2/checks', p, 4)
//删除考核项
export const delOneDormCheck = p => DELETEBODY('/dormv2/checks', p, 4)
//根据id查询考核项
export const getDormCheckById = p => GET('/dormv2/checks/{id}', p, 4)
//分页查询考核项列表
export const getDormCheckListPage = p => GET('/dormv2/checks/page', p, 4)

//获取模式列表
export const getDormScoresModesList = p => GET('/dormv2/modes', p, 4)

//评分管理
//评分查询
export const getDormScoresList = p => GET('/dormv2/scores', p, 4)
//新增评分
export const addOneDormScores = p => POST('/dormv2/scores', p, 4)
//编辑评分
export const editOneDormScores = p => POST('/dormv2/scores/update', p, 4)
//删除评分
export const delOneDormScores = p => DELETEBODY('/dormv2/scores', p, 4)
//根据id查询评分
export const getDormScoresById = p => GET('/dormv2/scores/{id}', p, 4)
//分页查询评分列表
export const getDormScoresListPage = p => GET('/dormv2/scores/page', p, 4)
//修改状态（完成、重评）
export const editGradeInfoState = p => PUT('/dormv2/scores/status', p, 4)
//宿舍文件上传
export const uploadDormPictures = p => POSTFormData('/dormv2/uploadFile', p, 4)

//费用管理
//新增收费
export const addOneDormFees = p => POSTFormData('/dormv2/fees', p, 4)
//删除收费
export const delOneDormFees = p => DELETEBODY('/dormv2/fees', p, 4)
//批量删除收费
export const delBatchDormScores = p => DELETEBODY('/dormv2/fees/removeBatch', p, 4)
//更新收费
export const editOneDormFees = p => POSTFormData('/dormv2/fees/update', p, 4)
//查询单个收费
export const getDormFeesById = p => GET('/dormv2/fees/{id}', p, 4)
//分页查询收费
export const getDormFeesListPaging = p => GET('/dormv2/fees/page', p, 4)
//导出模板下载
export const importCostModelUpload = p => download('/dormv2/fees/template', p, 4)
// 导入入住
export const importCost = p => POSTFormData('/dormv2/fees/importFee', p, 4)
//导出费用信息
export const exportDormCostPage = p => EXPORT('/dormv2/fees/exportFee', p, 4)

//获取位置树
// 根据当前登录用户获取宿舍位置菜单树
export const getDormLocationTreeByUser = p => GET('/dormv2/tree/list', p, 4)
// 根据localtion获取宿舍位置菜单树
export const getDormLocationTreeByLocation = p => POST('/dormv2/tree', p, 4)
// 根据位置id获取床位数量
export const getDormBedNumByLocationId = p => GET('/dormv2/bed/count', p, 4)

//测试
export const getDormlistByStudent = p => GET('/dormv2/tree/listByStudent', p, 4)

// 退换寝，保存通知人
export const saveAlertOthers = p => POST('/dormv2/returnOrExchange/notify', p, 4)

// 获取选中的通知人
export const selectAlertOthers = p => GET('/dormv2/notify/list', p, 4)

// 批量修改宿舍房型
export const batchRoomType = p => PUT('/dormv2/updateBatch', p, 4)

// 导出入住信息
export const studentCheckInInfo = p => EXPORT('/dormv2/exportLiving', p, 4)


// // 获取宿舍类型table
// export const getDormTypeTable = p => POST('/dormv2/dormType/query', p);
// // 新增宿舍类型
// export const addDormType = p => POST('/dormv2/dormType/add', p);
// // 编辑宿舍类型
// export const editDormType = p => POST('/dormv2/dormType/update', p);
// // 删除宿舍类型
// export const delDormType = p => POST('/dormv2/dormType/delete', p);
// // 获取宿舍用途table
// export const getDormPurposeTable = p => POST('/dormv2/dormpurpose/query', p);
// // 新增宿舍用途
// export const addDormPurpose = p => POST('/dormv2/dormpurpose/add', p);
// // 编辑宿舍用途
// export const editDormPurpose = p => POST('/dormv2/dormpurpose/update', p);
// // 删除宿舍用途
// export const delDormPurpose = p => POST('/dormv2/dormpurpose/delete', p);
// // 院系查询
// export const getDormInstitute = p => POST('/dormv2/dorminstitute/query', p);
// //新增院系
// export const addDormInstitute = p => POST('/dormv2/dorminstitute/add', p);
// //编辑院系
// export const editDormInstitute = p => POST('/dormv2/dorminstitute/update', p);
// //删除院系
// export const delDormInstitute = p => POST('/dormv2/dorminstitute/delete', p);

// // 学位查询
// export const getDormDegreeTable = p => POST('/dormv2/dormdegree/query', p);
// //新增学位
// export const addDormDegree = p => POST('/dormv2/dormdegree/add', p);
// //编辑学位
// export const editDormDegree = p => POST('/dormv2/dormdegree/update', p);
// //删除学位
// export const delDormDegree = p => POST('/dormv2/dormdegree/delete', p);

// // 退寝原因查询
// export const getDormRetireTable = p => POST('/dormv2/dormretire/query', p);
// // 新增退寝
// export const addDormRetire = p => POST('/dormv2/dormretire/add', p);
// // 编辑退寝
// export const editDormRetire = p => POST('/dormv2/dormretire/update', p);
// // 删除退寝
// export const delDormRetire = p => POST('/dormv2/dormretire/delete', p);

// // 学生查询
// export const getDormStudentTable = p => POST('/dormv2/student/query', p);
// // 新增学生
// export const addDormStudent = p => POST('/dormv2/student/add', p);
// // 编辑学生
// export const editDormStudent = p => POST('/dormv2/student/update', p);
// // 删除学生
// export const delDormStudent = p => POST('/dormv2/student/delete', p);
// // 学生入寝
// export const dormStudentCheckin = p => POST('/dormv2/student/checkInStu', p);
// // 学生换寝
// export const dormStudentExchange = p => POST('/dormv2/student/exchange', p);
// // 学生离寝
// export const dormStudentLeave = p => POST('/dormv2/student/leave', p);
// // 学生毕业
// export const dormStudentGraduate = p => POST('/dormv2/student/graduate', p);

// // 宿舍查询
// export const getDormInfoTable = p => POST('/dormv2/dorminfo/query', p);
// // 新增宿舍
// export const addDormInfo = p => POST('/dormv2/dorminfo/add', p);
// // 编辑宿舍
// export const editDormInfo = p => POST('/dormv2/dorminfo/update', p);
// // 删除宿舍
// export const delDormInfo = p => POST('/dormv2/dorminfo/delete', p);

// // 下载学生毕业导入模板
// export const exportgraduate = p => download('/dormv2/student/exportgraduate', p);
// // 下载学生新增导入模板
// export const exportnewstu = p => download('/dormv2/student/exportnewstu', p);
// // 下载学生宿舍导入模板
// export const exportdorm = p => download('/dormv2/dorm/dorminfo/exportdorm', p);
// // 下载电量导入模板
// export const exportelecinfo = p => download('/dormv2/elecinfo/exporteleinfo', p);

// /**
//  *  电费管理
//  * */

// //电费page
// export const pageElec = p => POST('/dormv2/elecinfo/query', p);
// //宿舍llist
// export const listDorm = p => POST('/dormv2/dorminfo/query', p);
// //电费add
// export const saveElec = p => POST('/dormv2/elecinfo/add', p);
// //电费update
// export const updateElec = p => POST('/dormv2/elecinfo/update', p);
// //电费delete
// export const deleteElec = p => POST('/dormv2/elecinfo/delete', p);
// //下载模板
// export const exporteleinfo = p => download('/dormv2/elecinfo/exporteleinfo', p);
// // 电量导入
// export const importElecinfo = p => uploading('/dormv2/elecinfo/addExcelImport', p);

// 学生出入记录
export const dormOutinRecords = p => GET('/dormv2/outin/records', p)

// 学生出入记录统计
export const dormOutinRecordsStatistics = p => GET('/dormv2/outin/record/statistics', p)
// 入住情况统计
export const getOccupancyStatistics = p => GET('/dormv2/occupancy/statistics', p)

// 根据房间请求统计数据
export const getDormitoryResullt = p => GET('/dormv2/room/statistics', p, 4)

// 根据床位请求统计数据
export const getStatisticsResullt = p => GET('/dormv2/bed/statistics', p, 4)

// 获取位置级联
export const getPosition = p => POST('/basic/location/list/bycollegeId', p, 4)

// 记录soket时间
export const recodeTime = p => POST('dormv2/outIn/records/updateGetSocketTimeById', p, 4)

// 一键查寝（全部和一键查寝）
export const getKnowingAKeyData = p => POST('/dormv2/occupancyRela/page', p, 4)

// 一键查寝（晚归）
export const getKnowingAKeyDataWG = p => POST('/dormv2/occupancyRela/getlaterBack', p, 4)

// 一键查寝（未归）
export const getKnowingAKeyDataWeiG = p => POST('/dormv2/occupancyRela/getnotBack', p, 4)

// 一键查寝（未出）
export const getKnowingAKeyDataWC = p => POST('/dormv2/occupancyRela/getnotGo', p, 4)

// 宿舍菜单树：校区，楼宇，楼层
export const getDormMenuTree = p => POST('/dormv2/room/location/list/byCollegeId', p, 4)

// 宿舍获取
export const getDormOp = p => GETNEW('/dormv2/room/list/DormNoByBuildingAndFloor', p, 4)

// 一键查寝(上一个还在用就是名字换了，现在这个叫一键查寝)
// 一键查寝（全部和一键查寝）
export const getKeyDorm = p => POST('/dormv2/studentViewAndRoom/page', p, 4)

// 一键查寝（在寝）
export const getKeyDormInRoom = p => POST('/dormv2/studentViewAndRoom/getInRoom', p, 4)

// 一键查寝（不在寝）
export const getKeyDormNotInRoom = p => POST('/dormv2/studentViewAndRoom/getNotInRoom', p, 4)

// 一键查寝（显示人数）
export const dormNumber = p => GET('/dormv2/studentViewAndRoom/getDormCount', p)


// 寝室划分
// 查询寝室划分计划
export const getDormDivision = p => POST('/dormv2/dormDivide/plans/page', p, 4)

// 获取学院范围
export const collegeScope = p => GET('/studentv2/faculty/list', p)

// 获取宿舍范围（老接口 正在用）
// export const dormScope = p => POST('/basic/location/detailed/list', p)

// 获取宿舍范围（新接口）
export const dormScopeNew = p => POST('/dormv2/room/list/camAndBuilingByCollegeId', p)

// 添加床位划分计划
export const dormDivisionPlan = p => POST('/dormv2/dormDivide/plans/insertDormDividePlan', p)

// 寝室划分详情
export const dormDividePlanDetail = p => GET('/dormv2/dormDivide/plans/dormDividePlanDetail', p)

// 根据计划ID获取校区楼宇列表
// export const getCampusBuildingList = p => GET('/dormv2/dormDivideConfig/getLongbuildings', p)
export const getCampusBuildingList = p => POSTNEW('/dormv2/dormDivideBedRe/getLongbuildings', p)

// 获取校区寝室房间列表
export const getRoomList = p => POST('/dormv2/dormDivideBedStu/getByLocationRow', p, 0, 20000)

// 根据计划Id获取对应的院系范围
export const getCollegeScope = p => GET('/dormv2/dormDivideConfig/getFacultys', p)

// 获取辅导员列表，按照学院分组
export const getInstructor = p => POSTNEW('/counselor/counselor-info/findList/groupbyfac', p)

// 辅导员下班级列表查询
export const getClass = p => POSTNEW('/studentv2/class/counselor/list', p)

// 根据宿舍ids获取床位数，房间数，房间宿舍号，待分配人数
export const getDistributionInfo = p => POST('/dormv2/room/getBedAndDormCountByIds', p)

// 释放房间
export const removeBatch = p => POST('/dormv2/dormDivideBedRela/realeaseRooms', p, 4)

// 学工批量划分学院(宿舍)
export const divisionCollege = p => POST('/dormv2/dormDivideBedRela/divideRoomsByCollege', p)

// 学工批量划分床位
export const divideBedByCollege = p => POST('/dormv2/dormDivideBedRela/divideBedByCollege', p)

// 学院划分辅导员（批量划分床位）
export const divideBedsByFacultyId = p => POSTNEW('/dormv2/dormDivideBedRela/divideBedsByFacultyId', p)

// 学院划分辅导员（批量划分宿舍）
export const divideRoomsByFacultyId = p => POSTNEW('/dormv2/dormDivideBedRela/divideRoomsByFacultyId', p)

// 根据宿舍Id获取床位信息（新划分用）
export const getDormInfo = p => POST('/dormv2/studentViewBed/getdormInfo', p)

// 划分完成修改状态
export const divisionCompleted = p => POST('/dormv2/dormDivideplanInfo/getPlanInfoStateByCollegeId', p)

// 划分颜色池
export const getAllColor = p => GET('/dormv2/dormDivideColor/getAllColor', p)

// 释放床位
export const updatebedByfacultyId = p => POST('/dormv2/dormDivideBedRela/realeaseBeds', p)

// 床位占用
export const updateStateByBeds = p => POST('/dormv2/room/updateStateByBeds', p)

// 学工页面显示房间数，床位数，各个学院
export const divideCountByCollegeId = p => GETNEW('/dormv2/dormDivideBedRe/divideCountByCollegeId', p)

// 分页条件查询学生基本信息列表
export const getStudentInfoab = p => POSTNEW('/dormv2/studentViewAndDivideBed/getStudentInfoByCounselorId', p)

// 辅导员查询专业
export const getMajorList = p => GETNEW('/counselor/counselor-info/counselor/majorList', p)

// 辅导员分配学生(床位)
export const divideBedsByStudent = p => POSTNEW('/dormv2/dormDivideBedRela/divideBedsByStudent', p)

// 辅导员自动划分学生（房间）
export const divideRoomsByStudent = p => POSTNEW('/dormv2/dormDivideBedRela/divideRoomsByStudent', p)

// 根据keyId获得未分配人数
export const getNotDivideStu = p => POSTNEW('/dormv2/room/getNotDivideStu', p)

// 获取学年列表
export const getSchoolYear = p => GETNEW('/studentv2/calendar/get/school-year', p)

// 寝室划分信息管理查询
export const getDivideStudentNum = p => POSTNEW('/dormv2/dormDivideBedRe/getDivideStudentNum', p)

// 导出寝室划分详情
export const exportDivideDorm = p => EXPORTNEW('/dormv2/dormDivideBedRe/exportDivideDorm', p)

// 修改状态为划分完成
export const updateDoneState = p => POSTNEW('/dormv2/dormDivide/plans/updateDoneState', p)

// 每个学院统计图界面显示
export const divideStudentEcharts = p => POSTNEW('/dormv2/dormDivideBedRe/divideStudent', p)

// 获取学年学期树
export const getSchoolYearTerm = p => GETNEW('/studentv2/calendar/get/school-year-term', p)

// 宿舍划分计划导入接口
export const importExportDormDivision = p => POSTFormDataNEW('/dormv2/dormDivideBedRela/importExport', p)

// 宿舍划分信息管理导入接口
export const importExportDormDivisionAdministration = p => POSTFormDataNEW('/dormv2/dormDivideBedRela/importExport2', p)

// 退寝
export const retreatRoom = p => POSTNEW('/dormv2/dormDivideBedRela/retireDorm', p)

// 分页查询全校未办理入住的集合
export const getStudentInfoNoEnter = p => POSTNEW('/dormv2/studentViewAndDivideBed/getStudentInfo', p)

// 办理入寝(新寝室入退换)
export const handleEnterRoom = p => POSTNEW('/dormv2/dormDivideBedRela/checkinAndSaveRecord', p)

// 宿舍批量退寝(新寝室划分)
export const batchRetreatRoom = p => POSTNEW('/dormv2/dormDivideBedRela/retireDormList', p)

// 办理调寝(新宿舍划分)
export const adjusttRoom = p => POSTNEW('/dormv2/dormDivideBedRela/adjustDorm', p)

// 查看学生已经入住的床位数,房间数，(入退换)分楼宇,性别
export const getAdjustDormCount = p => POSTNEW('/dormv2/dormDivideBedRe/adjustCountByCollege', p)

// 入住楼宇的房间总数量,未入住房间数量(左侧菜单栏)寝室...
export const getCampusBuildingListTransfer = p => POSTNEW('/dormv2/dormDivideBedRe/livingRoomCountBuilding', p)

// 民族验证接口
export const getCheckNationIndorm = p => GETNEW('/dormv2/dormDivideBedRela/checkNation', p)

// 宿舍统计图(床位,房间,楼宇,学生总数)
export const getDormitoryStatisticsData = p => POSTNEW('/dormv2/room/dormitoryStatistics', p)

// 宿舍统计图根据楼宇Id查询入住
export const getBuildingDataDormStatic = p => GETNEW('/dormv2/room/bedAndDormStaticBybuildingId', p)

// 查询辅导员寝室入退换是否走流程
export const getCounsellorExchangeProcess = p => GETNEW('/dormv2/dormCparam/getListByType', p)

// 提交辅导员寝室入退换是否走流程
export const submitCounsellorExchangeProcess = p => POSTNEW('/dormv2/dormCparam/updateSwtichByKey', p)

// 卫生评比，文明寝室导入
export const civilizedDormitoryimport = p => POSTFormDataNEW('/dormv2/scores/importScore', p)

// 确认寝室信息确认计划分页
export const getDormDeterminePlanTable = p => POSTNEW('/dormv2/doConfirm/plan/findPage', p)

// 修改寝室信息确认计划状态
export const changeDormDeterminePlanState = p => POSTNEW('/dormv2/doConfirm/plan/updateDoneState', p)

// 查看寝室信息确认计划详情
export const getDormDeterminePlanDetail = p => GETNEW('/dormv2/doConfirm/plan/dormDividePlanDetail', p)

// 创建寝室信息确认计划状态
export const creatDormDeterminePlan = p => POSTNEW('/dormv2/doConfirm/plan/saveOrUpdatePlan', p)

// 查看寝室信息确认学生详情
export const getDormDetermineStudentDetail = p => POSTNEW('/dormv2/doConfirm/student/page', p)

// 寝室信息确认学生催办
export const dormDetermineStudentUrging = p => POSTNEW('/dormv2/dormConfirm/urgingDormConfirm', p)

// 寝室信息确认查询原寝室信息
export const dormDetermineOriginalDormInfo = p => POSTNEW('/dormv2/dormConfirm/getInfoByNewBedAndOldBed', p)

//根据宿舍ID获取床位信息
export const getBedInfoByDormId = p => GETNEW('/dormv2/bed/infos/byDormId', p,6)

// 获取房型
export const getDormSpecList = p => POSTNEW('/dormv2/spec/getInfo', p, 5)

// 寝室信息确认 老师修改后提交
export const submitChangeDormDetermine = p => POSTNEW('/dormv2/dormConfirm/updateStudentDorm', p, 5)

// 获取学生寝室入换申请记录
export const getStudentTransferRecord = p => POSTNEW('/dormv2/dormApplyInfo/page', p, 5)

// 导出学生寝室入换申请记录审批单
export const exportStudentTransferRecord = p => EXPORTNEW('/dormv2/dormApplyInfo/export', p)

// 寝室入退换查询学生寝室信息
export const getBedInfoByStudentNo = p => GETNEW('/dormv2/bed/getBedInfoByStudentNo', p,6)

// 获取学生寝室入换日志
export const getTransferLogFile = p => POSTNEW('/dormv2/divide/adjustRecord/page', p, 5)

// 寝室划分信息管理查询宿舍
export const getDivideDormNumV2 = p => POSTNEW('/dormv2/dormDivideBedRe/getDivideDormNumV2', p)

// 寝室划分信息管理查询(新界面)
export const getDivideStudentNumV2 = p => POSTNEW('/dormv2/dormDivideBedRe/getDivideStudentNumV2', p)

// 寝室划分导出寝室
export const excelDivideDorm = p => POSTNEW('/dormv2/dormDivideBedRe/excelDivideDorm', p)

// 寝室划分导出学生
export const excelGetDivideStudentNumV2 = p => POSTNEW('/dormv2/dormDivideBedRe/excelGetDivideStudentNumV2', p)

// 通过楼层查询学生信息
export const getTempBedStudents = p => POSTNEW('/dormv2/adjustment/getTempBedStudents', p)

// 批量调寝保存
export const adjustList = p => POSTNEW('/dormv2/adjustment/adjustList', p)

// 办理调寝(新宿舍划分)
export const getInfoByKeyWords = p => GETNEW('/dormv2/bed/getInfoByKeyWords', p)

// 退寝(学生)
export const retireDormLd = p => POSTNEW('/dormv2/dormDivideBedRela/retireDormLd', p)

//如退换导出
export const exportImage = p => POSTNEW('/dormv2/room/exportImage', p)



// WEBPACK FOOTER //
// ./src/api/modules/dorm.js